import { render, staticRenderFns } from "./InnoNLife.vue?vue&type=template&id=3cd3ed1d&scoped=true"
import script from "./InnoNLife.ts?vue&type=script&lang=ts&external"
export * from "./InnoNLife.ts?vue&type=script&lang=ts&external"
import style0 from "./InnoNLife.vue?vue&type=style&index=0&id=3cd3ed1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd3ed1d",
  null
  
)

export default component.exports